module.exports = __webpack_public_path__ + "img/icon-data-diri-active.3386a9ee.svg";